export const I18N_DEFAULT_LOCALE = 'en'
export const I18N_LANGUAGES = [I18N_DEFAULT_LOCALE, 'de']
